var klaviyo = klaviyo || [];
    klaviyo.init({
      account: "QBj245",
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{ 
    trigger: {
      product_page_text: "Obvesti me, ko bo izdelek na voljo",
      product_page_class: "button",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },
    modal: {
     headline: "{product_name}",
     body_content: "Prijavi se in obvestili te bomo, ko bo ta izdelek spet na zalogi.",
     email_field_label: "E-pošta",
     button_label: "Obvesti me, ko bo na voljo",
     subscription_success_label: "Uspešna prijava! Obvestili te bomo, ko bo izdelek spet na voljo.",
     footer_content: '',
     additional_styles: "border-radius: 10px;",
     drop_background_color: "#000",
     background_color: "#fff",
     text_color: "#222",
     button_text_color: "#fff",
     button_background_color: "#3aaa35",
     close_button_color: "#ccc",
     error_background_color: "#fcd6d7",
     error_text_color: "#C72E2F",
     success_background_color: "#3aaa35",
     success_text_color: "#1B9500"
    }
  });